(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name cycle.factory:CosmicRadiationFactory
     *
     * @description
     *
     */
    angular
        .module('cycle')
        .factory('CosmicRadiationFactory', CosmicRadiationFactory);
    
    function CosmicRadiationFactory() { 
    	
    	//----declare DTOs------
    	//search cycle object
    	// function CycleSearchDTO(){    		
    	// 	this.cycleList =[];
    	// 	this.nextRecordsMonthFrom= null;
    	// 	this.nextRecordsMonthTo= null;
    	// 	this.nextRecordsCrewGroupCode= null;
    	// 	this.nextRecordsCrewGroups = null; 
        // }
    	
    	//grid view cycle object
    	// function CycleDTO(){
    	// 	this.cycleId = null;
    	// 	this.version= null;
    	// 	this.cycleName= null;
    	// 	this.dateFrom= null;
    	// 	this.dateTo= null;
    	// 	this.crewGroupCode= null;
    	// 	this.isValid = true;
    	// }
    	
    	//newly added Cycle object
    	function CosmicRadiationSaveRequestDTO(){
            this.destination= null;
            this.origin= null;
    		this.validFrom= null;
    		this.validTo= null;
    		this.exposure= null;    		
        }
        
        function CosmicRadiationDTO(configData) {
            this.cosmicId = null;
			this.origin = null;
			this.destination = null;
            this.records = [
                {
				  validFrom: '',
				  validTo: '',
                  exposure: 0 
                }
            ]
		}
 
    	//cycle delete request object
    	// function CycleDeleteRequestDTO(){
    	// 	this.cycleId = null;
    	// 	this.version= null;
    	// }	

        //----Define Function --------
    	//getter and setters of Cycle Search DTO
    	// function GetFormattedCycleSearchDTO(searchResponce){
    	// 	var cycleSearchDTO = new CycleSearchDTO();
    	// 	if(!!searchResponce.cycleList && searchResponce.cycleList.length>0){
    	// 		for(var i=0;i<searchResponce.cycleList.length;i++){
    	// 			var cycleDTO = new CycleDTO();
    	// 			cycleDTO.cycleId = searchResponce.cycleList[i].cycleId;
    	// 			cycleDTO.version = searchResponce.cycleList[i].version;
    	// 			cycleDTO.cycleName = searchResponce.cycleList[i].cycleName;
    	// 			cycleDTO.dateFrom = searchResponce.cycleList[i].dateFrom;
    	// 			cycleDTO.dateTo =searchResponce.cycleList[i].dateTo;
    	// 			cycleDTO.crewGroupCode = searchResponce.cycleList[i].crewGroupCode; 
    	// 			cycleSearchDTO.cycleList.push(cycleDTO) ;
    	// 		}
    	// 	}
    	// 	cycleSearchDTO.nextRecordsMonthFrom = searchResponce.nextRecordsMonthFrom;
    	// 	cycleSearchDTO.nextRecordsMonthTo = searchResponce.nextRecordsMonthTo;
    	// 	cycleSearchDTO.nextRecordsCrewGroupCode = searchResponce.nextRecordsCrewGroupCode;
    	// 	cycleSearchDTO.nextRecordsCrewGroups = searchResponce.crewGroups;
    	// 	return cycleSearchDTO;
    	// }
    	
    	// function GetCycleSearchDTO(){
    	// 	return new CycleSearchDTO();
    	// }
    	
    	//getter and setter of Cycle DTO
    	// function GetCycleDTO(){
    	// 	return new CycleDTO();
    	// }
    	
    	//getter and setter of Cycle Save Request
    	// function GetFormattedCycleSaveRequest(newCycle){
    	// 	var cycleSaveReq = new CycleSaveRequestDTO();
    	// 	cycleSaveReq.cycleName = newCycle.cycleName;
    	// 	cycleSaveReq.dateFrom = newCycle.dateFrom;
    	// 	cycleSaveReq.dateTo = newCycle.dateTo;
    	// 	cycleSaveReq.crewGroupCode = newCycle.crewGroupCode;
    	// 	return cycleSaveReq;
    	// }
    	
    	function GetCosmicRadiationSaveRequest(){
    		return new CosmicRadiationSaveRequestDTO();
        }
        
        function GetNewCosmicRadiation() {
            var cosmicRadiation = new CosmicRadiationDTO();

            return cosmicRadiation;
			// var user = new UserDTO();
			// user.version = -1;
			// user.userType = new UserTypeDTO();

			// var status = new StatusDTO();
    		// status.statusCode = "ACT";
    		// status.status = false ;
    		// user.status = status;

			// var userType = new UserTypeDTO();
			// user.userType = userType;

			// var crewType = new CrewTypeDTO();
			// user.crewTypeCode = crewType;

			// var password = new PasswordDTO();
			// user.password = password;

			// return user;
		}
    	
    	//getter and setter of Delete Request DTO
    	// function GetCycleDeleteRequestDTO(){
    	// 	return new CycleDeleteRequestDTO();
    	// }
    	
    	// function GetFormattedCycleDeleteRequestDTO(cycleDTO){
    	// 	var cycleDeleteReq = new CycleDeleteRequestDTO();
    	// 	cycleDeleteReq.cycleId = cycleDTO.cycleId;
    	// 	cycleDeleteReq.version = cycleDTO.version;
    	// 	return cycleDeleteReq;
    	// }
        
        //map services to return
        return {  
        	//getFormattedCycleSearchDTO : GetFormattedCycleSearchDTO,
        	//getCycleSearchDTO : GetCycleSearchDTO,
        	//getCycleDTO : GetCycleDTO,
        	//getFormattedCycleSaveRequest: GetFormattedCycleSaveRequest,
        	getCosmicRadiationSaveRequest : GetCosmicRadiationSaveRequest,
        	getNewCosmicRadiation : GetNewCosmicRadiation,
        	//getFormattedCycleDeleteRequestDTO : GetFormattedCycleDeleteRequestDTO
        }
 
    }
})();